module.exports = __webpack_public_path__ + "img/Compact-SR-Profiles.77b1f8bb.jpg";